// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__29rgf","large":"styles_large__27N2w"};